import { OverlayModule } from "@angular/cdk/overlay";
import { CommonModule } from "@angular/common";
import { isDevMode, ModuleWithProviders, NgModule } from "@angular/core";
import { MatButtonModule } from "@angular/material/button";
import { EffectsModule } from "@ngrx/effects";
import { ServiceWorkerEffects } from "./service-worker.effetcs";
import { SwUpdateNotificationComponent } from "./sw-update-notification/sw-update-notification.component";
import { provideServiceWorker } from "@angular/service-worker";
import {
    SharedServiceWorkerFeatureWebPushModule,
    WEB_PUSH_ENABLED,
    WEB_PUSH_VAPID_PUBLIC_KEY,
} from "shared/service-worker/feature-web-push";
import { SW_UPDATE_CHECK_INTERVAL } from "./injection-tokens";


type Config = {

    swEnabled?: boolean;
    featureWebPushEnabled?: boolean;

    /**
     * Check for ServiceWorker updates every x milliseconds.
     */
    swUpdateCheckInterval: number;

    vapidPublicKey: string;
}

@NgModule({
    imports: [
        CommonModule,
        MatButtonModule,
        OverlayModule,
        EffectsModule.forFeature([ServiceWorkerEffects]),
        SharedServiceWorkerFeatureWebPushModule,
        SwUpdateNotificationComponent,
    ],
    exports: [],
})
export class SharedServiceWorkerFeatureShellModule {
    public static forRoot(config: Config): ModuleWithProviders<SharedServiceWorkerFeatureShellModule> {
        return {
            ngModule: SharedServiceWorkerFeatureShellModule,
            providers: [
                { provide: WEB_PUSH_ENABLED, useValue: config.featureWebPushEnabled },
                { provide: SW_UPDATE_CHECK_INTERVAL, useValue: config.swUpdateCheckInterval },
                { provide: WEB_PUSH_VAPID_PUBLIC_KEY, useValue: config.vapidPublicKey },

                  provideServiceWorker('ngsw-worker.js', {
                      // to enable, set `production: true` in environment.ts or pass `--optimization=true` at build time
                      // enabled: !isDevMode(),
                      enabled: !isDevMode() && config.swEnabled,
                      // enabled: true,
                      // Register the ServiceWorker as soon as the application is stable
                      // or after 30 seconds (whichever comes first).
                      // more strategies: https://angular.dev/api/service-worker/SwRegistrationOptions#registrationStrategy
                      registrationStrategy: 'registerWhenStable:30000'
                      // registrationStrategy: 'registerImmediately'
                }),
            ]
        };
    }
}
